// @flow
import React from 'react';
import { connect } from 'react-redux';

import { selectOpenModalTypeIs, selectSubscribeModal } from '../../selectors/modals';

import ConversionForm from '../premium/ConversionForm';

import styles from '../../views/Subscribe.css';

import * as uiActions from '../../actions/ui';
import * as analyticsActions from '../../actions/analytics';

import Modal from './Modal';
import { selectStripeIsLoading } from '../../selectors/stripe';

type MapStateToProps = {
  isOpen: boolean,
  plan: string,
  isStripeLoading: boolean,
};

type DispatchProps = {
  closeModal: Function,
  analyticsTrack: Function,
};

type Props = MapStateToProps & DispatchProps;

const SubscribeModal = ({ plan, isOpen, closeModal, analyticsTrack, isStripeLoading }: Props) => {
  const onComplete = () => {
    closeModal();
  };

  const onClose = () => {
    analyticsTrack('Closed Subscription Modal');
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      data-test="subscribe-modal"
      contentLabel="subscribe-modal"
      shouldCloseOnOverlayClick={false}
      hideCloseButton={isStripeLoading}
      fullScreen
    >
      <ConversionForm
        className={styles.form}
        onComplete={onComplete}
        plan={plan}
        onClose={onClose}
      />
    </Modal>
  );
};

function mapStateToProps(state: Object): MapStateToProps {
  const { plan } = selectSubscribeModal(state);
  return {
    isOpen: selectOpenModalTypeIs(state, 'SUBSCRIBE_MODAL'),
    plan,
    isStripeLoading: selectStripeIsLoading(state),
  };
}

const dispatchProps: DispatchProps = {
  closeModal: uiActions.hideModal,
  analyticsTrack: analyticsActions.track,
};

export default connect(mapStateToProps, dispatchProps)(SubscribeModal);

export { SubscribeModal as PureSubscribeModal };
